module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Im1kaTpmaW5hbmNlIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTYgMTYuNUwzIDE5LjQ0VjExSDZNMTEgMTQuNjZMOS40MyAxMy4zMkw4IDE0LjY0VjdIMTFNMTYgMTNMMTMgMTZWM0gxNk0xOC44MSAxMi44MUwxNyAxMUgyMlYxNkwyMC4yMSAxNC4yMUwxMyAyMS4zNkw5LjUzIDE4LjM0TDUuNzUgMjJIM0w5LjQ3IDE1LjY2TDEzIDE4LjY0IiBmaWxsPSJibGFjayIvPgo8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/mdi_finance.svg
// module id = 1gsO
// module chunks = 0